import { useState, useEffect } from "react";
import {
  getPresidentList,
  getVicePresidentList,
  getRegions,
} from "../../../../api/ph-api";
import { SeoTag, CxenseParseTag } from "../../../../../components/seo/SeoTag";
import RacesPage from "../../../../../components/races/RacesPage";

export const getStaticProps = async () => {
  let presidential = await getPresidentList();
  let vPresidential = await getVicePresidentList();
  let regionList = await getRegions();

  if (!presidential || !vPresidential || !regionList) {
    return {
      props: { presidential, vPresidential, regionList },
      revalidate: 5
    };
  }

  return {
    props: { presidential, vPresidential, regionList },
  };
};

const PresVpNational = ({ presidential, vPresidential, regionList }) => {
  const [url, setUrl] = useState("");
  const title =
    "Candidates for president and vice president - 2022 Philippine elections";
  const description =
    "Get to know who's running for president and vice-president in the 2022 Philippine elections. Bookmark this page to see partial, unofficial, real-time election results from the Comelec media server after polls close on May 9. The percentage of votes received is computed based on the total number of actual voters in each contest.";
  const keywords =
    "2022 Philippine elections, #PHVote, Philippine elections, presidential candidates philippines, vice-presidential candidates philippines";
  const og_image = "https://www.rappler.com/tachyon/2022/03/ATIN-PILIPINAS.jpg";

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <>
      <SeoTag
        title={title}
        description={description}
        keywords={keywords}
        og_image={og_image}
        twitter_og_image={og_image}
        twitter_title={title}
        twitter_description={description}
      />
      <CxenseParseTag title={title} />
      <RacesPage
        path="president-vice-president"
        presidential={presidential}
        vPresidential={vPresidential}
        regionList={regionList}
        url={url}
      />
    </>
  );
};

export default PresVpNational;
